/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesPlayoffsApplicationPlayoffsGetPlayoffDetailPlayoffDetailScoreResponse { 
    playoffScoreId?: string;
    playoffScoreLegacyId?: number;
    playoffHoleId?: string;
    playoffHoleLegacyId?: number;
    score?: number;
    submittedAt?: Date;
    submittedBy?: string;
    verified?: boolean;
}